var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-p-10"},[_c('a',{staticClass:"button is-primary",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Launch Full Values Report")])])
}
var staticRenderFns = []

export { render, staticRenderFns }